// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BZ2_HIDE_TERMS = "Skry podmienky";
export const BZ2_SHOW_COMPLETE_TERMS = "Zobraz cel\u00e9 podmienky";
export const BZ2_TERMS = "Podmienky";
export const counter_ENTRIES = ["%(counter)s inzer\u00e1t", "%(counter)s inzer\u00e1ty", "%(counter)s inzer\u00e1tov"];
export const counter_RATINGS = ["%(counter)s hodnotenie", "%(counter)s hodnotenia", "%(counter)s hodnoten\u00ed"];
